export class BaseModel {
    id: string;

    constructor() {

    }
}
